import { Button } from '@mui/material'
import React from 'react'
import GenerateIcon from './GenerateIcon'
import { useDispatch } from 'react-redux'
import { updateQuickNotificationDetails } from '../features/notifications/notificationsSlice'
import { AxiosResponse } from 'axios'
import { LoadingButton } from '@mui/lab'
import { handleRequestError } from '../services/api'

interface IProps {
    itemId: number,
    secret_key: string,
    hide?: boolean,
    disableRefresh?: boolean,
    refreshToken?: (itemId: number) => Promise<AxiosResponse>,
}

export default function SecretKey(props: IProps) {

    const dispatch = useDispatch()

    const [isShown, setIsShown] = React.useState<boolean>(false)
    const [newToken, setNewToken] = React.useState<string>("")
    const [loadng, setLoading] = React.useState<boolean>(false)

    const {
        itemId,
        secret_key,
        hide,
        disableRefresh,
        refreshToken,
    } = props

    const serializeKey = () => {
        let token: string = secret_key

        if (!disableRefresh && newToken){
            token = newToken
        }

        if (hide && token){
            if (isShown){
                return token
            }
            return token.slice(0, 3) + "********************"
        }

        return token
    }

    const copyToClipboard = async (text: string) => {
        try {
            await navigator.clipboard.writeText(text);
            updateQuickNotificationDetails(true, "Copied!", "success", dispatch)
        } catch (err) {
            console.error("Failed to copy", err);
        }
    }

    const handleRefresh = () => {
        if (!refreshToken){
            return;
        }

        setLoading(true)

        refreshToken(itemId)
            .then(response => {
                const { data } = response

                if (data.token){
                    setNewToken(data.token)
                }

                setLoading(false)
                updateQuickNotificationDetails(true, data.message, "success", dispatch)

            })
            .catch(error => {
                setLoading(false)
                handleRequestError(error, dispatch)
            })
    }

    return(
        <div className="secret-key-box-container">
            <div className="content-of-secret-key-box-container">

                <div className="mask-of-secret-key-box-container">
                    <div className="content-of-mask-of-secret-key-box-container">
                        {/* {hide && <Button className="general-button" variant="outlined" startIcon={<GenerateIcon icon={isShown ? "hide" : "show"} />} onClick={() => setIsShown(isShown ? false : true)}>{isShown ? "Hide" : "Show"}</Button>} */}
                        <Button className="general-button" variant="outlined" startIcon={<GenerateIcon icon="copy" />} onClick={() => copyToClipboard(newToken ? newToken : secret_key)}>Copy</Button>
                        {!disableRefresh && <LoadingButton className="general-button" variant="outlined" startIcon={<GenerateIcon icon="refresh" />} loading={loadng} onClick={() => handleRefresh()}>Refresh</LoadingButton>}
                    </div>
                </div>

                <p className="secret-key">{serializeKey()}</p>
            </div>
        </div>
    )
}   